import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

// Stale-while-revalidate cache: show last-known data instantly, refresh in the background.
const PREFIX = "rs_cache:";
const mem = new Map();

export const readCache = (path) => {
  if (mem.has(path)) return mem.get(path);
  try {
    const raw = sessionStorage.getItem(PREFIX + path);
    if (raw) { const v = JSON.parse(raw); mem.set(path, v); return v; }
  } catch (_) {}
  return undefined;
};

export const writeCache = (path, data) => {
  mem.set(path, data);
  try { sessionStorage.setItem(PREFIX + path, JSON.stringify(data)); } catch (_) {}
};

export const clearCache = () => {
  mem.clear();
  try { Object.keys(sessionStorage).filter(k => k.startsWith(PREFIX)).forEach(k => sessionStorage.removeItem(k)); } catch (_) {}
};

export const prefetch = (path) => api.get(path).then(r => { writeCache(path, r.data); return r.data; }).catch(() => {});

// Returns [data, reload]; data is undefined only when nothing is cached yet.
export function useCachedGet(path) {
  const [data, setData] = useState(() => readCache(path));
  const reload = useCallback(() => api.get(path).then(r => { writeCache(path, r.data); setData(r.data); return r.data; }), [path]);
  useEffect(() => { setData(readCache(path)); reload().catch(() => {}); }, [path, reload]);
  return [data, reload];
}
